import type { PageContent } from "../types";

export const sitemap: PageContent = {
  slug: "sitemap",
  title: "Sitemap | Phil Carr",
  description:
    "Sitemap for Phil Carr SEO consultant and web design services, including service pages, local SEO pages, blog articles, and contact information.",
  body: `# Sitemap

## Main pages

- [Home](/)
- [About](/about)
- [Services](/services)
- [SEO](/seo)
- [Web Design](/web-design)
- [Projects](/projects)
- [Areas Covered](/areas)
- [Blog](/blog)
- [FAQs](/faqs)
- [Contact](/contact)

## SEO services

- [SEO Website Audits](/seo/bespoke-seo-website-audits)
- [Organic SEO Services](/seo/organic-seo-services)
- [Technical SEO](/seo/technical-seo-support)
- [Link Building Outreach](/seo/link-building-outreach)
- [Trades SEO](/seo/trades)
- [SEO for Builders](/seo/trades/builders)
- [SEO for Electricians](/seo/trades/electricians)
- [SEO for Plumbers](/seo/trades/plumbers)
- [SEO for Contractors](/seo/trades/contractors)
- [SEO for Accountants](/seo/sectors/accountants)
- [SEO for Hairdressers](/seo/sectors/hairdressers)
- [SEO for Law Firms](/seo/sectors/law-firms)
- [SEO for Solicitors](/seo/sectors/solicitors)
- [SEO for Private Dental Practices](/seo/sectors/private-dental-practices)

## Local SEO by area

- [SEO in Barnsley](/seo/barnsley)
- [SEO in Doncaster](/seo/doncaster)
- [SEO in Huddersfield](/seo/huddersfield)
- [SEO in Leeds](/seo/leeds)
- [SEO in Rotherham](/seo/rotherham)
- [SEO in Sheffield](/seo/sheffield)
- [SEO in Wakefield](/seo/wakefield)
- [Barnsley SEO & Web Design](/areas/barnsley)

## Web services

- [Sentinel Door Systems project](/projects/sentinel-door-systems)
- [Oracle Training Consultants project](/projects/oracle-training-consultants)
- [WordPress Websites](/wordpress-websites)
- [Shopify Websites](/shopify-websites)
- [Software Development](/software-development)
- [Bespoke App Development](/bespoke-app-development)
- [Website Management](/website-management)
- [Hosting](/hosting)

## Legal

- [Privacy Policy](/privacy-policy)
- [Cookie Policy](/cookies)
- [Terms & Conditions](/terms-and-conditions)
`,
};
